import { GraphValues } from "./GraphValues";

export interface FoodCostData {
    articolo: string;
    incasso: number;
    percentuale_incasso: number;
    quantita: number;
    percentuale_quantita: number;
    costo: number;
    percentuale_foodcost: number;
    netto: number;
}

export class PiattoBi {
    piattoMigliore!: string;
    piattoPeggiore!: string;
    modificaPiuRichiesta!: string;
    categoriaMigliore!: string;
    foodCostMedio!: string;
    piattoMiglioreList!: GraphValues[];
    categoriaMiglioreList!: GraphValues[];
    foodCostData!: FoodCostData[];

    static fromJson(json: any): PiattoBi {
        let result = new PiattoBi();
        result.piattoMigliore = json.piattoMigliore;
        result.piattoPeggiore = json.piattoPeggiore;
        result.modificaPiuRichiesta = json.modificaPiuRichiesta;
        result.foodCostMedio = json.foodCostMedio;
        result.categoriaMigliore = json.categoriaMigliore;
        result.piattoMiglioreList = json.piattoMiglioreList?.map((value: any) => GraphValues.fromJson(value)) || [];
        result.categoriaMiglioreList = json.categoriaMiglioreList?.map((value: any) => GraphValues.fromJson(value)) || [];
        result.foodCostData = json.foodCostData || [];
        return result;
    }
}